<button mat-icon-button class="dialog__close" (click)="close()" [attr.aria-label]="'pages.profile.avatar.dialog.close' | transloco">
  <i class="fas fa-xmark" aria-hidden="true"></i>
</button>

<h2 mat-dialog-title class="dialog__title">{{ 'pages.profile.avatar.dialog.title' | transloco }}</h2>

<input #fileUpload type="file" class="file-input" accept=".png,.jpg,.jpeg,.svg" (change)="fileChangeEvent($event)" hidden />

<mat-dialog-content class="dialog__content">
  @if (!imageFile) {
    <!-- Large clickable upload area -->
    <button type="button" class="dropzone" (click)="fileUpload.click()">
      <i class="fas fa-cloud-arrow-up dropzone__icon" aria-hidden="true"></i>
      <span class="dropzone__title">{{ 'pages.profile.avatar.dialog.choose' | transloco }}</span>
    </button>
  } @else {
    <div class="cropper-wrapper">
      <image-cropper
        [imageFile]="imageFile"
        [maintainAspectRatio]="true"
        [roundCropper]="true"
        [aspectRatio]="1"
        [resizeToWidth]="256"
        [onlyScaleDown]="false"
        format="jpeg"
        [imageQuality]="90"
        [transform]="transform"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded($event)"
        (loadImageFailed)="imageLoadFailed()">
      </image-cropper>
    </div>

    <div class="transform-buttons">
      <button mat-icon-button (click)="rotateCcw()" [attr.aria-label]="'pages.profile.avatar.dialog.rotateLeft' | transloco">
        <i class="fas fa-rotate-left" aria-hidden="true"></i>
      </button>
      <button mat-icon-button (click)="zoomOut()" [attr.aria-label]="'pages.profile.avatar.dialog.zoomOut' | transloco">
        <i class="fas fa-magnifying-glass-minus" aria-hidden="true"></i>
      </button>
      <button mat-icon-button (click)="zoomIn()" [attr.aria-label]="'pages.profile.avatar.dialog.zoomIn' | transloco">
        <i class="fas fa-magnifying-glass-plus" aria-hidden="true"></i>
      </button>
      <button mat-icon-button (click)="rotateCw()" [attr.aria-label]="'pages.profile.avatar.dialog.rotateRight' | transloco">
        <i class="fas fa-rotate-right" aria-hidden="true"></i>
      </button>
    </div>

    <button type="button" class="change-photo" (click)="fileUpload.click()">
      <i class="fas fa-arrows-rotate" aria-hidden="true"></i>
      {{ 'pages.profile.avatar.dialog.changePhoto' | transloco }}
    </button>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog__actions">
  <app-button variant="outline" color="primary" [block]="true" [disabled]="loading" (btnClick)="close()">
    {{ 'pages.profile.avatar.dialog.cancel' | transloco }}
  </app-button>

  <app-button variant="filled" color="primary" [block]="true" [disabled]="!croppedImage || loading" (btnClick)="confirm()">
    @if (loading) {
      <span class="action-btn__spinner" aria-hidden="true">⟳</span>
    }
    {{ 'pages.profile.avatar.dialog.confirm' | transloco }}
  </app-button>
</mat-dialog-actions>
